import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/first-cycle-paids',
    name: 'first-cycle-paid',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/first-cycle-paid/index.vue')
  }
]
